import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getVisits, removeVisit } from 'slice/visitSlice';
import AdminTable from 'common/AdminTable';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getUploadUrl } from 'utils/uploadUrl';

const List = () => {
    const dispatch = useDispatch();
    const { data: visits, loading } = useSelector((state) => state.visit);

    useEffect(() => {
        dispatch(getVisits());
    }, [dispatch]);

    const getImageUrl = (imgJson) => {
        try {
            const images = JSON.parse(imgJson);
            const firstImg = images[0];
            return getUploadUrl(firstImg);
        } catch (e) {
            return '';
        }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e67e22',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeVisit(id));
            }
        });
    };

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Place Name', accessor: 'name' },
        {
            Header: 'Image',
            accessor: 'images',
            Cell: ({ value }) => (
                <img src={getImageUrl(value)} alt="" width="100" className="rounded shadow-sm" />
            ),
        },
        { Header: 'Rating', accessor: 'rating' },
        { Header: 'Status', accessor: 'status', Cell: ({ value }) => (value === 1 ? 'Active' : 'Inactive') },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button className="btn removebtn mx-1" onClick={() => handleDelete(row.original.id)}>
                        Remove
                    </button>
                    <Link to={`/khajuraho/visits/update/${row.original.id}`} className="btn editbtn mx-1">
                        Edit
                    </Link>
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Khajuraho Places to Visit</h4>
                <Link to="/khajuraho/visits/add" className="btn btn-light btn-sm font-weight-bold">
                    Add Place
                </Link>
            </div>
            <div className="mt-4">
                {loading ? (
                    <div className="text-center text-white">Loading...</div>
                ) : (
                    visits?.length > 0 ? (
                        <AdminTable tableHeaders={tableHeaders} tableData={visits} />
                    ) : (
                        <div className="text-center text-white">No places found.</div>
                    )
                )}
            </div>
        </div>
    );
};

export default List;
